import type { PredictionMarketSnapshot } from "@roman/shared/types/PredictionMarket";
import { normalizeChoicesPercentage } from "@roman/shared/utils/predictionMarket/utils";

export type Choice = {
  id: string;
  name: string;
  latestProbability?: number;
};

/**
 * Get default selected choices based on the latest probabilities
 * Returns top 4 choices if more than 4 choices exist, otherwise returns all choices
 */
export const getDefaultSelectedChoices = (
  allChoices: Choice[],
  predictionMarketHistory: PredictionMarketSnapshot[],
): string[] => {
  if (allChoices.length <= 4) {
    return allChoices.map((choice) => choice.id);
  }

  // Get the latest snapshot
  const latestSnapshot = predictionMarketHistory[predictionMarketHistory.length - 1];
  if (!latestSnapshot) {
    return allChoices.slice(0, 4).map((choice) => choice.id);
  }
  const normalizeChoices = normalizeChoicesPercentage(latestSnapshot.predictionChoiceStates);

  // Sort choices by probability in descending order and take top 4
  const sortedChoices = [...normalizeChoices]
    .sort((a, b) => b.probability - a.probability)
    .slice(0, 4)
    .map((state) => state.choiceId);

  return sortedChoices;
};
